module.exports = __webpack_public_path__ + "media/images/ic-clock-azul-f038770fa6b7ead22a97cdcf9f6fdcbc.svg";